import { render, staticRenderFns } from "./ChatbotStatusWidget.vue?vue&type=template&id=55ce0a75&scoped=true"
import script from "./ChatbotStatusWidget.vue?vue&type=script&lang=js"
export * from "./ChatbotStatusWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatbotStatusWidget.vue?vue&type=style&index=0&id=55ce0a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ce0a75",
  null
  
)

export default component.exports